export default __webpack_public_path__ + "static/media/defaultIcon.de292f5a.png";